import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "antd";
import InfoMenu from "../components/InfoMenu";
import RegionEmbed from "../components/RegionEmbed";

const Image1 = require("../assets/original/_DA_8653_med.jpg");

export default function OgdensCondobolin() {
    const [activeLink, setActiveLink] = useState("tripPlanner");

    useEffect(() => {
        document.body.classList.add("PageOgdensCondobolin");
        return () => {
            document.body.classList.remove("PageOgdensCondobolin");
        };
    }, []);

    return (
        <div className="OgdensCondobolin PageSingle" style={{ paddingBottom: "50px" }}>
            <section
                className="PageHero Cover"
                style={{ backgroundImage: `url(${Image1})`}}
            >
                <div className="AppContainer">
                    <h1 className="title" style={{ marginBottom: "8px" }}>
                        Ogdens Condobolin
                    </h1>
                    <h2 className="title" style={{ marginBottom: "0" }}>
                        Condobolin
                    </h2>
                    <InfoMenu
                        activeLink={activeLink}
                        setActiveLink={setActiveLink}
                        showPassengerTimetables={false}
                    />
                </div>
            </section>
            <div className="AppContainer">
                <Row gutter={[20, 0]}>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }}>
                        <Card bordered={false} className="CardEmbed">
                            <RegionEmbed
                                operatorId="ogdens_condobolin"
                                activeLink={activeLink}
                                search={window.location.search}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
